import Bowser from 'bowser';
import { getHtml } from '~/actions/extraHTML/wheelOfFortune/html/getHtml';
import { _ } from '~/actions/triggers/generalNotification';
import { NotificationConfig } from '~/actions/triggers/types';
const { platform } = Bowser.parse(window.navigator.userAgent);
import { getCss } from './styles/getCss';

export interface IWheelSector {
  id: number;
  name: string;
  backgroundColor: string;
  textColor: string;
}

export interface IWheelAnimationProps {
  winSectorNumber: number;
  coupon?: string;
  title: string;
  message?: string;
}

export interface IWheelProps {
  '@type': 'WheelOfFortune';
  sectors: IWheelSector[];
  arrowColor: string;
  animationProps: IWheelAnimationProps;
}

export class WheelOfFortune {
  static ITERATOR = 0;

  wheelParams: IWheelProps;
  configuration: NotificationConfig;
  localIterator: number;

  constructor(params: IWheelProps, configuration?: NotificationConfig) {
    WheelOfFortune.ITERATOR = +1;
    this.localIterator = WheelOfFortune.ITERATOR;
    this.wheelParams = params;
    this.configuration = configuration;
  }

  get isMobile() {
    return platform.type === 'mobile';
  }

  get isBefore() {
    return !this.isMobile;
  }

  get isAfter() {
    return this.isMobile;
  }

  get html() {
    return getHtml(this.localIterator, _, this.isMobile, this.wheelParams);
  }

  get css() {
    return getCss(this.localIterator, _, this.wheelParams, this.configuration);
  }

  get mobileClass() {
    return `${_}notification_with_wheel_mobile_${this.localIterator}`;
  }

  get desktopClass() {
    return `${_}notification_with_wheel_desktop_${this.localIterator}`;
  }

  get commonClass() {
    return `${_}notification_with_wheel_${this.localIterator}`;
  }

  get notificationWrapClass() {
    const deviceClass = this.isMobile ? this.mobileClass : this.desktopClass;
    const commonClass = this.commonClass;

    return `${commonClass} ${deviceClass}`;
  }
}
